import CheckboxUntyped from "@components/base/checkbox/checkbox";
import { useEffect, useRef } from "react";
import type { ReactElement } from "react";
import { toggleFilterValue } from "../utils";
import type { BulkLogStatus } from "../types";
import { LOG_STATUS_OPTIONS } from "./constants";

const Checkbox = CheckboxUntyped as unknown as (props: Record<string, unknown>) => ReactElement;

type LogStatusFilterProps = {
  selected: BulkLogStatus[];
  onChange: (selected: BulkLogStatus[]) => void;
  onClose: () => void;
};

const LogStatusFilter = ({ selected, onChange, onClose }: LogStatusFilterProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) onClose();
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  return (
    <div ref={containerRef} className="tw-absolute tw-right-0 tw-top-full tw-z-50 tw-mt-2 tw-w-[260px] tw-rounded-xl tw-border tw-border-gray-200 tw-bg-white tw-shadow-autoSuggest">
      <div className="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-gray-200 tw-px-4 tw-py-3">
        <span className="tw-text-sm tw-font-semibold tw-text-gray-900">Filters</span>
        <button type="button" disabled={!selected.length} onClick={() => onChange([])} className="tw-border-none tw-bg-transparent tw-p-0 tw-text-sm tw-font-medium tw-text-primary-purple-600 disabled:tw-text-gray-400">
          Clear all
        </button>
      </div>

      <div className="tw-px-4 tw-py-3">
        <div className="tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-gray-500">Status</div>
        {LOG_STATUS_OPTIONS.map((option) => (
          <div key={option.key} className="tw-mt-2 tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-gray-900">
            <Checkbox id={`log-status-${option.key}`} checked={selected.includes(option.key)} onChange={() => onChange(toggleFilterValue(selected, option.key))} label={option.label} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LogStatusFilter;
